"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefreshIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.RefreshIcon = (0, react_1.forwardRef)(function RefreshIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", 
            // eslint-disable-next-line max-len
            d: "M3.71301 8.99987C3.59071 8.9998 3.47028 8.96984 3.36221 8.91257C3.25414 8.85531 3.16172 8.77248 3.09299 8.67132C3.02427 8.57015 2.98132 8.45371 2.96791 8.33215C2.95449 8.21059 2.971 8.08758 3.01601 7.97387L4.87801 3.26886C4.9282 3.14207 5.01202 3.03136 5.12044 2.94864C5.22886 2.86592 5.35779 2.81433 5.49334 2.79942C5.62889 2.78451 5.76595 2.80684 5.88976 2.864C6.01357 2.92117 6.11945 3.01101 6.19601 3.12386L7.09601 4.45186C8.71367 3.40137 10.626 2.89836 12.5512 3.01698C14.4764 3.1356 16.3125 3.86958 17.7889 5.11072C19.2654 6.35186 20.3041 8.03451 20.7518 9.91063C21.1996 11.7868 21.0328 13.7571 20.276 15.5313C19.5192 17.3054 18.2124 18.7895 16.5483 19.7647C14.8842 20.74 12.9508 21.1548 11.0331 20.9481C9.11539 20.7414 7.31482 19.924 5.8968 18.6165C4.47878 17.309 3.51833 15.5805 3.15701 13.6859C3.10755 13.4252 3.16368 13.1555 3.31305 12.9362C3.46242 12.7168 3.6928 12.5658 3.95351 12.5164C4.21422 12.4669 4.4839 12.523 4.70322 12.6724C4.92254 12.8218 5.07355 13.0522 5.12301 13.3129C5.40411 14.7847 6.1501 16.1275 7.25126 17.1438C8.35242 18.16 9.75064 18.7961 11.2403 18.9585C12.7299 19.1208 14.2323 18.8009 15.5265 18.0457C16.8208 17.2906 17.8385 16.14 18.4301 14.7633C19.0217 13.3865 19.1559 11.8563 18.8129 10.3976C18.47 8.93896 17.668 7.62883 16.525 6.65992C15.3819 5.69102 13.9581 5.11448 12.463 5.01511C10.9678 4.91573 9.48024 5.29876 8.21901 6.10786L9.38601 7.82887C9.46246 7.94158 9.50678 8.07299 9.5142 8.20899C9.52163 8.34499 9.49188 8.48044 9.42814 8.60081C9.36441 8.72118 9.26911 8.82192 9.15246 8.89222C9.0358 8.96253 8.90221 8.99974 8.76601 8.99987H3.71201H3.71301Z", fill: "currentColor" })));
});
